import api from '../api';
import { BuildingsResponse } from '../models';

export class BuildingService {
  public list = () => api.get<BuildingsResponse[]>('/pwa/building');
}

const buildingService = new BuildingService();
export default buildingService;
